<template>
  <div class="col pl-2 col-md-6 details docs-details pr-0 photo-documentation-content">
<!--    <vue-confirm-dialog></vue-confirm-dialog>-->
    <modal-popup v-if="show_popup" @close="photoDocDetails" @save="saveDocumentDetails">
      <h4>Möchten Sie die Änderungen speichern?</h4>
    </modal-popup>
    <div id="photodoku">
      <div class="innerdoc position-relative edit-photospage" id="edit-coverpage">
        <div class="header col-md-12">
          <div class="row">
            <div class="col-md-6 pl-lg-0">
              <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </div>
            <div class="col-md-6 text-right">
              <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </div>
          </div>
        </div>
        <div class="picdetail">
          <div class="text-center">
            <h2 class="font-weight-bold">Dokumentation</h2>
            <h3 v-if="doc.reporttype == '0'" class="text-capitalize p-1 mb-2"> {{ dateFormat( doc.reportdate)}} </h3>
            <input type="text" v-if="doc.reporttype == '1'" class="form-control text-dark report-name m-2  text-center" v-model="doc.reportname" placeholder="Hier Berichtsname eintragen"/>
            <input type="text" v-else class="form-control m-2 text-center report-name text-dark  text-dark" v-model="doc.time" placeholder="Hier Berichtsname eintragen"/>
            <h3 class="mb-2 text-capitalize">{{ project.name }}</h3>
          </div>
        </div>
        <div class="mt-2 text-center">
          <img :src="project_img" class="img-thumbnail img-fluid" alt="img">
        </div>
        <div class="picdetail pt-md-5 pt-2">
          <div class="project-info">
            <p>Projekt : {{ project.name }}  </p>
            <p> Projektnummer : {{ project.number }} </p>
            <p class="text-capitalize"> Projektverantwortlicher : {{ project.manager }}</p>
            <p>Projektbeginn : {{  dateFormat(project.startdate) }}</p>
          </div>
        </div>
        <p class="text-center border-top position-absolute foot pb-2">
          Seite 1  von {{ Math.ceil(images.length / 2) + 2 }}
          <span class="float-right">projectdocu.com</span>
        </p>
      </div>
    </div>

    <textarea-tab :logo_one="logo_one" :logo_two="logo_two"/>

    <photo-details :is_one_photo="doc.reportparams.singlephotopage" :logo_one="logo_one" :logo_two="logo_two"/>


    <div class="doku-btns-sticky_v2 pt-1">
      <span class="btninner">
        <button type="button" @click="$router.push({name: 'photoDocumentation',params:  {id: $route.params.id}})" class="btn btn-danger">Abbrechen</button>
        <button type="button" @click="saveDocumentDetails" class="btn btn-primary" :disabled="$route.name === 'photoDocumentEdit' && imagesLoading">
          Speichern
        </button>
      </span>
    </div>
  </div>
</template>
<script>

import PhotoDetails from './PhotoDetails/PhotoDetails'
import TextareaTab from './TextareaTab'
import TextareaTwoTab from './TextareaTwoTab'
import { mapState } from 'vuex'
import {formatDate, setAspectRatio} from '../../common'
import ModalPopup from "../../custom/ModalPopup";
export default {
  components: {
    ModalPopup,
    PhotoDetails,
    TextareaTab,
    TextareaTwoTab
  },
  data () {
    return {
      config: {},
      isHeadingOneEdit: false,
      saveable: true,
      show_popup: false
    }
  },
  mounted () {
    this.$root.$on('updateEdit', () => {
      this.showMainTab();
    });
    setAspectRatio()
  },
  created () {
    if (this.logoOne === '' || !this.logoTwo){
      this.$store.dispatch("getProjectDetails",this.$route.params.id)
    }
  },

  methods: {

    groupBy(array, key){
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]){
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
    dateFormat : (val) => formatDate(val),

    showMainTab () {
      if (this.$route.name === 'photoDocumentEdit'){
        this.show_popup = true;
      }else {
        let prm = {id: this.$route.params.id}
        this.$router.push({name: 'photoDocumentation',params: prm})
      }
    },


    // Main Method For Saving the Document Details
    async saveDocumentDetails () {
      // Test for Async Report generation
       this.$store.commit('toggleLoading', true)
       this.$parent.loading = true
      if (this.$route.name === 'photoDocumentEdit'){
         await this.$store.dispatch('updatePhotoDocument', {id: this.$route.params.id, currentuserid: this.user.pduserid, currentusername: `${this.user.firstname} ${this.user.lastname}`})
         await this.$router.push({name: 'photoDocumentationPreview',params: {id: this.$route.params.id , docId: this.$route.params.docId}})

        // doc.generated = false
        // let docindex = this.$store.state.photoDocumentation.photoDocuments.findIndex((docl) => docl.pdreportid == doc.pdreportid)
        // // console.log('DocIndex', docindex, this.$store.state.photoDocumentation.photoDocuments[docindex])
        // this.$store.state.photoDocumentation.photoDocuments[docindex].generated = true
        // // this.$store.state.photoDocumentation.photoDocuments[docindex].reportname = this.$store.state.photoDocumentation.photoDocuments[docindex].reportname + ' MyAdd'
        //
        // await this.$store.dispatch('setGenerateStateToDocument', {id: this.$route.params.id, currentuserid: this.user.pduserid, currentusername: `${this.user.firstname} ${this.user.lastname}`})
        // this.$store.dispatch('updatePhotoDocument', {id: this.$route.params.id, currentuserid: this.user.pduserid, currentusername: `${this.user.firstname} ${this.user.lastname}`})
        // this.$router.push({name: 'photoDocumentationPreview',params: {id: this.$route.params.id , docId: this.$route.params.docId}})

      } else {
        // PreCreate Document and then update...
        this.doc.pduserid = this.user.pduserid
        this.doc.creator = `${this.user.firstname} ${this.user.lastname}`
        await this.$store.dispatch('saveDocument', {id: this.$route.params.id})
        await this.$router.push({name: 'photoDocumentation',params: {id: this.$route.params.id}})
      }
      // Test for Async Report generation
       this.$store.commit('toggleLoading', false)
       this.$parent.loading = false
    },


   async photoDocDetails(){
          const doc = this.doc;
          this.show_popup = false;
          this.$store.commit('toggleLoading', true)
          let projectId = this.$route.params.id
          await this.$router.push({
            name: 'photoDocumentationPreview',
            params: { id: projectId.toString(), docId: doc.pdreportid || 0 }
          })
        this.$store.commit('toggleLoading', false)
    }
  },

  computed: {
    ...mapState({
      isLoading : state => state.photoDocumentation.isLoading,
      showCoverPhoto: state =>  state.photoDocumentation.showCoverPhoto,
      isImgFromPhotos: state =>  state.photoDocumentation.isImgFromPhotos,
      coverImage: state =>  state.photoDocumentation.coverPhoto,
      theme: state =>  state.photoDocumentation.selectedTemplate,
      photoDetails: state =>  state.photoDocumentation.photoDetailsPage,
      project: state =>  state.appSettings.project,
      logo_one: state =>  state.appSettings.logoOne,
      logo_two: state =>  state.appSettings.logoTwo,
      project_img: state =>  state.appSettings.projectImage,
      user: state => state.projects.user
    }),

    imagesLoading() {
      if(!this.saveable) {
        return this.saveable
      }

      let result =  this.$store.state.photoDocumentation.selectedImages.length < this.$store.state.photoDocumentation.selectedDocument.pdreportitems.length
      this.saveable = result

      return result
    },

    images () {
      if (this.doc.reporttype == '0'){
        return this.$store.state.photoDocumentation.dailyReportPhotos
      }else {
        return this.$store.state.photoDocumentation.selectedImages
      }
    },
    doc () {
      if (this.$route.name === 'photoDocumentEdit'){
        return  this.$store.state.photoDocumentation.selectedDocument
      }else {
        return this.$store.state.photoDocumentation.newDocumentDetails
      }
    }
  },

}
</script>

<style>
  h1 , h2 , h3 , h4 {
    margin-bottom: 7px;
  }
  .docs-details{
    height: calc(100vh - 143px);
    overflow-y: auto;
  }
  @media (max-width: 800px) {
    .docs-details {
      height: calc(100vh - 165px);
      overflow-y: auto;
    }
  }
  .docs-details::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #ffffff;
  }
  .docs-details::-webkit-scrollbar-thumb{
       border-radius: 10px;
       -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.6);
       background-color: #3399ff9e;
       opacity: 1;
  }
  .docs-details::-webkit-scrollbar{
    width: 9px;
    background-color: #ffffff;
  }

  [contenteditable] {
    outline: 0 solid transparent;
  }
  .innerdoc .header{
    min-height: 4rem;
  }
  .form-control.report-name{
    border: 1px dashed #2c6ed5;
    font-size: 1.26rem;
    font-weight: 500;
  }
  .doku-btns-sticky_v2{
    bottom: 1px;
    z-index: 100;
    position: -webkit-sticky;
    position: fixed;
    text-align: center;
    width: 49.5%;
    right: 0;
    background: #ffffff7a;
    border-top: 1px solid grey;
  }
  .doku-btns-sticky_v2 button{
    font-size: 14px;
    font-weight: normal !important;
    padding: 4px 16px;
    line-height: inherit;
  }
  .picdetail p{
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/DetailsRightTab.vue